import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { catchError, tap, map } from 'rxjs/operators';
import { NgForm } from '@angular/forms';
import { QuestionResponse } from '../models/assets/QuestionResponse';

import { API_SETTINGS } from './API_SETTINGS';

const httpOptions = {
  headers: new HttpHeaders({'Content-Type': 'application/json'})
};

const apiUrl = API_SETTINGS.API_URL + 'QuestionResponse';

@Injectable({
  providedIn: 'root'
})
export class ApiQuestionResponseService {
  
  constructor(private http: HttpClient) { }

  private handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
  
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead
  
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  getQuestionResponses (): Observable<QuestionResponse[]> {
    const url = apiUrl+'/GetQuestionResponses';
    return this.http.get<QuestionResponse[]>(url).pipe();
  }

  getQuestionResponse(id: number): Observable<QuestionResponse> {
    const url = `${apiUrl}/GetQuestionResponse/${id}`;
    return this.http.get<QuestionResponse>(url).pipe();
  }

  addQuestionResponse(questionResponse: QuestionResponse): Observable<QuestionResponse>{  
    const url = apiUrl+'/PostQuestionResponse';
    return this.http.post<QuestionResponse>(url, questionResponse, httpOptions).pipe();
  }

  updateQuestionResponse (id: number, QuestionResponse: any): Observable<QuestionResponse>{
    const url = `${apiUrl}/PutQuestionResponse/${id}`;
    return this.http.put(url, QuestionResponse, httpOptions).pipe(
      tap((QuestionResponseRes: QuestionResponse) => true ), //console.log()),
      catchError(this.handleError<QuestionResponse>('updateQuestionResponse'))
    )
  } 
 
  setResponseUploadStatusComplete(id: number, QuestionResponse: any): Observable<QuestionResponse>{
    const url = `${apiUrl}/PutQuestionResponseUploadStatusComplete/${id}`;
    return this.http.put(url, QuestionResponse, httpOptions).pipe(
      tap((QuestionResponseRes: QuestionResponse) => console.log()),
      catchError(this.handleError<QuestionResponse>('Set Question Response Upload Status Complete'))
    )
  }

  deleteQuestionResponse(id: number): Observable<QuestionResponse> {
    const url = `${apiUrl}/DeleteQuestionResponse/${id}`;
    return this.http.delete<QuestionResponse>(url, httpOptions).pipe();
  }
  
  QuestionResponseExists(id: number): Observable<boolean> {
    const url = `${apiUrl}/QuestionResponseExists/${id}`;
    return this.http.get<boolean>(url, httpOptions).pipe();
  }

  GetQuestionResponsesWithQuestionAssetId(id: number): Observable<QuestionResponse[]> {
    const url = `${apiUrl}/GetQuestionResponsesWithQuestionAssetId/${id}`;
    return this.http.get<QuestionResponse[]>(url, httpOptions).pipe();
  }
}
